import ProductCardComponent from "./components/product-card";
import {isEmptyObject} from "./utils/is-empty-object";
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import {RenderPosition, render} from "./utils/render";
import {setAddCart} from "./require/set-add-cart";
import {setCountCartHeader} from "./init-cart";
import GoodsComponent from "./components/goods-component";
import LiComponent from "./components/li";
import FavoritesController from "./controllers/favorites";
import {getProductData} from "./parsing/product";
import LabelsController from "./controllers/labels";
import {getCart} from "./require/get-cart";


const updateCart = (onDataChange) => {
  if (window.location.pathname !== `/cart`) {
    return;
  }

  getCart({
    resolveHandler: (response) => {
      onDataChange(response);
    }
  });
};


export const renderGoods = (container, className, goodsName, data, onDataChange = () => {}) => {
  const productList = data.items;
  if (isEmptyObject(productList)) {
    return;
  }

  const wrapComponent = new GoodsComponent({
    className,
    goodsName,
    title: data.title,
  });

  const actionListElement = wrapComponent.getElement().querySelector(`.main-page__list`);

  Object.values(productList)
  .forEach((itemData) => {
    const product = getProductData(itemData);

    const liItemComponent = new LiComponent({
      className: `actions__item swiper-slide`,
    });
    render(actionListElement, liItemComponent.getElement(), RenderPosition.BEFOREEND);

    const productCardComponent = new ProductCardComponent({
      data: product,
    });

    productCardComponent.setCartButtonClickHandler((cb) => {
      setAddCart(itemData.item_id, (response) => {
        setCountCartHeader(response.cart_count);
        updateCart(onDataChange);

        cb();
      });
    });

    productCardComponent.setCartLinkButtonClickHandler(() => {
      window.open(`/cart`, `_blank`);
    });

    new LabelsController({
      className: `preview-product`,
      labels: product.labels,
      itemId: product.itemId,
    }).render(productCardComponent.getElement());

    new FavoritesController({
      className: `preview-product`,
      itemId: product.itemId,
      isCheck: product.isFavorite,
    }).render(productCardComponent.getElement());

    render(liItemComponent.getElement(), productCardComponent.getElement(), RenderPosition.BEFOREEND);
  });

  render(container, wrapComponent.getElement(), RenderPosition.BEFOREEND);

  const sw = new Swiper(`.swiper--${goodsName}`, {
    modules: [Navigation],
    direction: `horizontal`,
    spaceBetween: 10,
    centeredSlides: true,
    slideActiveClass: `actions__item--active`,

    navigation: {
      nextEl: `.swiper__button--next`,
      prevEl: `.swiper__button--prev`,
      hiddenClass: `main-page__swiperButton--hidden`,
      disabledClass: `main-page__swiperButton--disabled`,
      lockClass: `main-page__swiperButton--lock`
    },

    breakpoints: {
      320: {
        slidesPerView: 2,
      },
      560: {
        slidesPerView: 3,
        centeredSlides: false,
      },
      920: {
        slidesPerView: 4,
        centeredSlides: false,
      },
      1100: {
        slidesPerView: 4,
        centeredSlides: false,
      }
    }
  });
};
